import FilePicker from "@/components/FilePicker";
import ImageCompontent from "@/components/Image";
import { STATUS as UPLOAD_STATUS } from "@/components/PinCreator/PinUploader/ImageAvatar";
import uploadAccept from "@/constants/uploadAccept";
import { uploadFile } from "@/services";
import imageUrl from "@/utils/imageUrl";
import { Button, Checkbox, Upload } from "antd";
import classNames from "classnames";
import { useMemo, useState } from "react";
import HBMessage from "../../HBMessage";
import styles from "./index.module.less";
export default function UploadCover({ boardTitle, coverImg, setCoverImg }) {
  const [status, setStatus] = useState(
    coverImg?.ossFile ? UPLOAD_STATUS.DONE : UPLOAD_STATUS.NEW
  );

  const onFilePicked = async (file) => {
    if (file.size >= 20 * 1024 * 1024) {
      HBMessage.error(`图片【${file.name}】太大，单张图片体积不超过 20 MB`);
      return;
    }
    try {
      setStatus(UPLOAD_STATUS.UPLOADING);
      const result = await uploadFile(file, ({ loaded, total }) => {
        setCoverImg({ ...coverImg, progress: (loaded / total) * 100 });
      });
      // 处理状态码为200，但是后端返回的错误
      if (result.err) {
        if (coverImg?.ossFile) {
          setStatus(UPLOAD_STATUS.DONE);
        } else {
          setStatus(UPLOAD_STATUS.NEW);
        }
      } else {
        // 提前预加载图片
        const image = new Image();
        image.src = imageUrl(result);
        image.onload = function () {
          setStatus(UPLOAD_STATUS.DONE);
        };
        image.onerror = function () {
          setStatus(UPLOAD_STATUS.DONE);
        };
        setCoverImg({ ...coverImg, ossFile: result });
      }
    } catch (error) {
      if (coverImg?.ossFile) {
        setStatus(UPLOAD_STATUS.DONE);
      } else {
        setStatus(UPLOAD_STATUS.NEW);
      }
    }
  };
  const onChange = () => {
    setCoverImg({ ...coverImg, syncBoard: !coverImg.syncBoard });
  };

  const imgClassName = useMemo(() => {
    /**
     * 1.图片宽>高，高度固定
     * 2.图片宽<=高 宽度固定
     */

    if (coverImg?.ossFile?.width > coverImg?.ossFile?.height) {
      return "heightFixed";
    } else {
      return "widthFixed";
    }
  }, [coverImg]);
  return (
    <div className={styles.wrapper}>
      <div className={classNames([styles.content, styles[imgClassName]])}>
        {status === UPLOAD_STATUS.NEW && (
          <FilePicker
            accept={uploadAccept}
            className={styles.filePicker}
            onPick={onFilePicked}
            maxAmount={1}
            multiple={false}
            trackData={{
              "data-gd-click": "button_click",
              "data-button-name": "封面上传按钮",
            }}
            tip="尺寸480*320px，小于20MB"
          />
        )}
        {status === UPLOAD_STATUS.UPLOADING && (
          <div className={styles.cover}>
            <div className={styles.progressContainer}>
              <div
                className={styles.progress}
                style={{ width: `${coverImg.progress}%` }}
              />
            </div>
          </div>
        )}
        {(status === UPLOAD_STATUS.UPLOADING ||
          status === UPLOAD_STATUS.DONE) && (
          <div className={styles.imgContent}>
            {coverImg?.ossFile && (
              <ImageCompontent
                className={classNames([styles.img, "transparent-img-bg"])}
                src={imageUrl(coverImg?.ossFile)}
                alt="封面"
                width={400}
              />
            )}
            {status !== UPLOAD_STATUS.UPLOADING && (
              <Upload
                maxCount={1}
                name="file"
                className={styles.reUpload}
                accept={uploadAccept}
                customRequest={({ file }) => {
                  onFilePicked(file);
                }}
                showUploadList={false}
              >
                <Button
                  className={styles.reBtn}
                  data-gd-click={"button_click"}
                  data-button-name={"封面上传按钮"}
                >
                  重新上传
                </Button>
              </Upload>
            )}
          </div>
        )}
      </div>
      <Checkbox
        className={styles.checkbox}
        onChange={onChange}
        checked={coverImg?.syncBoard}
      >
        同步封面至画板「{boardTitle}」
      </Checkbox>
    </div>
  );
}
